import React from 'react';
import {
  Dialog,
  DialogContent,
  DialogTitle,
  IconButton,
  Typography,
  Grid,
} from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import { withStyles } from '@material-ui/core/styles';
import EditProductForm from '../EditProductForm';

const StyledDialog = withStyles({
  paper: {
    margin: 16,
    boxShadow: 'none',
    width: '100%',
    maxWidth: 1100,
  },
})(Dialog);

export default function ModalEditProduct({
  open,
  onClose,
  styleCode,
  onSaved,
}) {
  return (
    <StyledDialog open={open} onClose={onClose} maxWidth={false} fullWidth>
      <DialogTitle style={{ padding: '16px 24px' }}>
        <Grid container justifyContent="space-between" alignItems="center">
          <Typography
            style={{
              fontFamily: 'Montserrat',
              fontSize: 18,
              letterSpacing: '0.1em',
            }}
          >
            EDIT PRODUCT INFO
          </Typography>
          <IconButton onClick={onClose} size="small">
            <CloseIcon />
          </IconButton>
        </Grid>
      </DialogTitle>
      <DialogContent style={{ paddingBottom: 32 }}>
        {open && styleCode && (
          <EditProductForm styleCode={styleCode} onSaved={onSaved} />
        )}
      </DialogContent>
    </StyledDialog>
  );
}
